import { ShoppingBag, LogOut } from "lucide-react";
import { useNavigate } from "react-router";

import logo from "@/assets/images/logos/logo-trud.webp";
import { Button } from "@/components/ui/button";
import { useAuthActions, useAuthUser } from "@/context/auth/AuthContext";

/**
 * Pantalla única para usuarios `type === "buyer"`.
 *
 * La app de gestión (trd-client) es solo para negocios. Un buyer (cliente
 * final) no debe ver el sidebar ni ningún módulo: solo este placeholder con
 * identidad de Trud y la opción de cerrar sesión. A futuro este espacio será
 * su portal de compras (MiTrud).
 */
export default function BuyerWelcome() {
  const navigate = useNavigate();
  const user = useAuthUser();
  const { logout } = useAuthActions();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const firstName = user?.name?.split(" ")?.[0];

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-100 px-6 text-center text-text-primary">
      <img src={logo} alt="Trud" className="mb-10 h-9 w-auto" />

      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary">
        <ShoppingBag className="h-10 w-10" />
      </div>

      {firstName && (
        <p className="mb-2 font-raleway text-lg text-text-secondary">
          ¡Hola, {firstName}!
        </p>
      )}

      <h1 className="max-w-xl text-3xl font-semibold leading-tight md:text-4xl">
        Próximamente vas a ver todas tus compras en un solo lugar
      </h1>

      <p className="mt-4 max-w-md font-raleway text-text-secondary">
        Estamos construyendo tu espacio personal en Trud. Te avisamos apenas
        esté listo.
      </p>

      <Button
        variant="outline"
        onClick={handleLogout}
        className="mt-10"
        size="lg"
      >
        <LogOut className="mr-2 h-4 w-4" />
        Cerrar sesión
      </Button>
    </div>
  );
}
